import { render } from "./forminput.vue?vue&type=template&id=63b7c534"
import script from "./forminput.vue?vue&type=script&lang=js"
export * from "./forminput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__